import * as React from 'react'
import { OutlinedTextFieldProps } from '@mui/material/TextField';
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import {EnterKeyHandlerProps, withEnterKeyHandler} from './hoc/withEnterKeyHandler'

import { TextField } from '@mui/material';

const PPOutlinedTextField = (props: OutlinedTextFieldProps & ErrorHandlingFormProps & EnterKeyHandlerProps) => {
    const {hasError, messages, clearErrorMessage, eventKeys, eventEmitter, ...rest} = props
    return <TextField {...rest} error={hasError} variant="standard" />;
}
PPOutlinedTextField.displayName = 'PPOutlinedTextField'
export default createErrorHandlingForm(withEnterKeyHandler(PPOutlinedTextField))
